import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { LoginComponent } from './login/login.component';
import { OtpComponent } from './otp/otp.component';
import { ValidateUserComponent } from './validate-user/validate-user.component';
import { ForgotPasswordComponent } from './forgot-password/forgot-password.component';
import { ChangePasswordComponent } from './change-password/change-password.component';
import { PasswordExpiredComponent } from './password-expired/password-expired.component';
import { RegisterEmailComponent } from './register-email/register-email.component';

const routes: Routes = [{ path: '', component: LoginComponent },
{ path: 'otp', component: OtpComponent },
{ path: 'validateuser', component: ValidateUserComponent },
{ path: 'forgotpassword', component: ForgotPasswordComponent },
{ path: 'changepassword', component: ChangePasswordComponent },
{ path: 'passwordexpired', component: PasswordExpiredComponent },
{ path: 'registeremail', component: RegisterEmailComponent }];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class LoginRoutingModule { }
